import { getHomePage } from '../repositories/pageRepository'
import { getProducts } from '../repositories/productRepository'
import {
  getBrands,
  getManufacturers,
  getCategories,
  getTags,
  getSearchResults,
  seller,
} from '../repositories/productRepository'

async function fetchHomePageData(data) {
  const newPagedata = await getHomePage(data)
  return newPagedata
}

async function fetchCategoryPageData(query, options, themeName) {
  const { categoryName, categorySlug, filter, ...params } = query
  const themesWithCategoryFilter = ['Getz', 'Fashion', 'Moonshot', 'Zopnow']

  // Format category data
  const categoryData = {
    categoryName: categorySlug || categoryName,
    params: {
      includeCategory: themesWithCategoryFilter.includes(themeName),
    },
  }

  // Format product data
  const productData = {
    params: {
      ...params,
      filter: filter,
      category: categorySlug || categoryName,
      storeId: options.storeId,
    },
  }

  const [layoutResponse, productResponse] = await Promise.all([
    getCategories(categoryData, options),
    (filter || query?.sorting) && getProducts(productData, options),
  ])

  let initialProductsData = {}
  let layoutResponseFilter = {}

  if (layoutResponse?.page?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.page?.layouts.find(
      (layout) => layout.name === 'ProductCollection'
    )

    if (
      productCollectionLayout &&
      productCollectionLayout.value &&
      productCollectionLayout.value.collection
    ) {
      layoutResponseFilter =
        productCollectionLayout.value.collection.filters ||
        productResponse?.filters ||
        {}
      initialProductsData = productCollectionLayout?.value?.collection || {}
    }
  }
  const pageData = layoutResponse?.page || {}
  const collectionData =
    query?.filter || query?.sorting ? productResponse : initialProductsData

  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...collectionData,
            filters: layoutResponseFilter,
          },
        },
        data: {
          ...layout.data,
          loadMoreType: layout?.data?.loadMoreType ?? 'INFINITE',
          layoutType: 'GRID',
          sorting: query?.sorting || '',
        },
      }
    }
    return layout
  })

  return pageData
}

async function fetchSearchPageData(query, options) {
  const params = query
  const dataSearch = {
    params,
  }

  const productData = {
    params: {
      ...query,
    },
  }

  const [layoutResponse, productResponse] = await Promise.all([
    getSearchResults(dataSearch, options),
    (query?.filter || query?.sorting) && getProducts(productData, options),
  ])

  const pageData = layoutResponse || {}
  let initialProductsData = {}
  let layoutResponseFilter = {}
  if (layoutResponse?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.layouts?.find(
      (layout) => layout.name === 'ProductCollection'
    )

    if (
      productCollectionLayout &&
      productCollectionLayout.value &&
      productCollectionLayout.value.collection
    ) {
      layoutResponseFilter =
        productCollectionLayout.value.collection.filters || {}
      initialProductsData = productCollectionLayout?.value?.collection || {}
    }
  }
  const collectionData =
    query?.filter || query?.sorting ? productResponse : initialProductsData
  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...collectionData,
            filters: layoutResponseFilter,
          },
        },
      }
    }
    return layout
  })

  pageData.entity = {
    slug: params.q,
    name: 'Search results',
  }

  pageData.layouts = (pageData.layouts || []).map((layout) => {
    return {
      ...layout,
      data: { ...layout.data, layoutType: 'GRID', loadMoreType: 'INFINITE' },
    }
  })

  return pageData
}

async function fetchBrandPageData(query, options, themeName, sorting, filter) {
  const { brandName, ...params } = query
  params.brand = brandName
  const brandData = {
    brandName,
    ...(themeName === 'Getz' && {
      params: {
        sorting: 'A-Z',
      },
    }),
  }

  const productData = {
    params: {
      brandName,
      filter,
      sorting,
    },
  }

  const [layoutResponse, productResponse] = await Promise.all([
    getBrands(brandData, options),
    (filter || sorting) && getProducts(productData, options),
  ])

  let layoutResponseFilter = {}
  let initialProductsData = {}

  if (layoutResponse?.page?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.page?.layouts?.find(
      (layout) => layout.name === 'ProductCollection'
    )

    if (
      productCollectionLayout &&
      productCollectionLayout.value &&
      productCollectionLayout.value.collection
    ) {
      layoutResponseFilter =
        productCollectionLayout.value.collection.filters || {}
      initialProductsData = productCollectionLayout?.value?.collection || {}
    }
  }
  const pageData = layoutResponse?.page || {}

  const collectionData =
    filter || sorting ? productResponse : initialProductsData
  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...collectionData,
            filters: layoutResponseFilter,
          },
        },
        data: {
          ...layout.data,
          loadMoreType: 'INFINITE',
          layoutType: 'GRID',
        },
      }
    }
    return layout
  })
  return pageData
}

async function fetchManufacturerPageData(query, options, themeName) {
  const { manufacturerName, ...params } = query
  params.manufacturer = manufacturerName
  const manufacturerData = {
    params: {
      Manufacturer: manufacturerName,
      ...(themeName === 'Getz' && {
        sorting: 'A-Z',
      }),
    },
  }

  const [layoutResponse] = await Promise.all([
    getManufacturers(manufacturerData, options),
  ])

  let layoutResponseCollection = {}
  if (layoutResponse?.page?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.page?.layouts.find(
      (layout) => layout.name === 'ProductCollection'
    )

    if (
      productCollectionLayout &&
      productCollectionLayout.value &&
      productCollectionLayout.value.collection
    ) {
      layoutResponseCollection = productCollectionLayout.value.collection || {}
    }
  }
  const pageData = layoutResponse?.page || {}
  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...layoutResponseCollection,
          },
        },
        data: {
          ...layout.data,
          loadMoreType: 'INFINITE',
          layoutType: 'GRID',
        },
      }
    }
    return layout
  })
  return pageData
}

async function fetchTagPageData(query, options) {
  const { tagName, filter, sorting, ...params } = query
  params.tag = tagName
  const tagData = {
    tagName,
  }
  const productData = {
    params: {
      tagName,
      sorting,
      filter,
    },
  }
  const [layoutResponse, productResponse] = await Promise.all([
    getTags(tagData, options),
    (query?.filter || query?.sorting) && getProducts(productData, options),
  ])
  let initialProductsData = {}
  let layoutResponseFilter = {}
  if (layoutResponse?.layouts?.length > 0) {
    const productCollectionLayout = layoutResponse?.layouts?.find(
      (layout) => layout.name === 'ProductCollection'
    )

    if (
      productCollectionLayout &&
      productCollectionLayout.value &&
      productCollectionLayout.value.collection
    ) {
      layoutResponseFilter =
        productCollectionLayout.value.collection.filters || {}
      initialProductsData = productCollectionLayout?.value?.collection || {}
    }
  }
  const pageData = layoutResponse || {}
  const collectionData =
    query?.filter || query?.sorting ? productResponse : initialProductsData

  pageData.layouts = (pageData.layouts || []).map((layout) => {
    if (layout.name === 'ProductCollection') {
      return {
        ...layout,
        value: {
          ...layout.value,
          collection: {
            ...collectionData,
            filters: layoutResponseFilter,
          },
        },
        data: {
          ...layout.data,
          loadMoreType: layout?.data?.loadMoreType ?? 'INFINITE',
          layoutType: 'GRID',
          sorting: query?.sorting || '',
        },
      }
    }
    return layout
  })

  return pageData
}
async function fetchSellerPageData(options) {
  const response = await seller(options)
  return response
}

export {
  fetchHomePageData,
  fetchCategoryPageData,
  fetchSearchPageData,
  fetchBrandPageData,
  fetchTagPageData,
  fetchManufacturerPageData,
  fetchSellerPageData,
}
